import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { DetailTypePracticeCrubs } from 'practice/constants/type-practice-crubs';
import FormTypePractice, { FormTypePracticeVM } from 'practice/components/type-practice/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { TypePracticeData } from 'shell/models/type-practice';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { typePracticeResponseTransformer } from 'practice/utils/typepractice-response-transformer';

const DetailTypePractice = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-tipo-pratica');
  });

  const [typePractice] = useHttpFetch<HttpResponse<TypePracticeData>, FormTypePracticeVM>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-pratica/${params?.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {
          key: {
            tipoPratica: params?.id,
          },
        },
      },
      transformer: typePracticeResponseTransformer,
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={DetailTypePracticeCrubs} />
      {typePractice.isLoading || typePractice.pristine || typePractice.hasErrors ? undefined : (
        <FormTypePractice
          title="Dettaglio Tipo Pratica"
          onCancel={onCancel}
          initialValues={typePractice?.data as FormTypePracticeVM}
          disabled
        />
      )}
    </Fragment>
  );
};

DetailTypePractice.displayName = 'Edit Type Practice Page component';

export default DetailTypePractice;
